import { Common, color } from '@stockbit/ui';
import { useDispatch } from 'react-redux';

import slice from './slice';

const { Iconmoon, IconWrapper } = Common;
const { actions } = slice;

type propTypes = { id: string };

const ListCloseIcon = ({ id = '' }: propTypes) => {
  const dispatch = useDispatch();

  const handleCloseClick = () => {
    dispatch(actions.setDeleteId({ id }));
  };

  return (
    <IconWrapper padding="0 5px" onClick={handleCloseClick}>
      <Iconmoon
        className="icon-widget_close"
        color={color.sunsetOrange}
        hoverColor={color.sunsetOrange}
        size="14px"
        weight="bold"
      />
    </IconWrapper>
  );
};

export default ListCloseIcon;
